import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "@openedx/paragon";
import { FormattedMessage } from "@edx/frontend-platform/i18n";

import UnitButton from "./UnitButton";
import { useModel } from "../../../../generic/model-store";
export default function SequenceNavigationDropdown({
  unitId,
  onNavigate,
  showCompletion,
  unitIds,
}) {
  const { title: unitTitle } = useModel("units", unitId) || {};

  return (
    <Dropdown className="sequence-navigation-dropdown d-none">
      <Dropdown.Toggle
        variant="link"
        className="font-weight-normal w-100 border-right-0"
      >
        {unitTitle}
      </Dropdown.Toggle>
      <Dropdown.Menu className="w-100">
        {unitIds.map((buttonUnitId) => (
          <Dropdown.Item
            as={UnitButton}
            className="w-100"
            isActive={unitId === buttonUnitId}
            key={buttonUnitId}
            onClick={onNavigate}
            showCompletion={showCompletion}
            showTitle
            unitId={buttonUnitId}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

SequenceNavigationDropdown.propTypes = {
  unitId: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  showCompletion: PropTypes.bool.isRequired,
  unitIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};
